import React from 'react';
import { FrontPageInterface } from './front-page.interface';
import styles from './front-page.module.scss';
import LineByLine from '../line-by-line/line-by-line.component';
import LetterByLetter from '../letter-by-letter/letter-by-letter.component';

const FrontPage: React.FunctionComponent<FrontPageInterface> = () => {
  return (
    <div className={styles.component}>
      <div className={styles.content}>
        <h1 className={styles.title}>
          <LetterByLetter text="Forbes Россия и Meta в&nbsp;разговоре с&nbsp;лидерами: На&nbsp;пути в&nbsp;цифровое будущее" />
        </h1>

        <hr className={styles.border} />

        <h3 className={styles.subtitle}>
          <LineByLine text="Индивидуальные решения для крупнейших российских компаний" />
        </h3>

        <div className={styles.description}>
          <div>
            <LineByLine text="Искусственный интеллект и математические алгоритмы, аналитические модели и Big Data, цифровые каналы и продуктовые механики… Высокие технологии покоряют мир маркетинга и делают его все более изобретательным, и при этом более доступным малому бизнесу с ограниченным бюджетом. По своим задачам цифровой маркетинг не отличается от традиционного: это все тот же поиск точек развития бизнеса и выстраивание прочных отношений с потребителями. О том, как связаны цифровизация и эффективность, мы поговорили с топ-менеджерами «Сбера», Unilever и «Яндекс». Узнать об опыте лидеров можно в трех форматах — видео, подкаст и классический текст. Выбирайте, что для вас лучше." />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FrontPage;
